import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RoutesPaths } from "../../Router/constant";

const paymentLoaderStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100vw",
    height: "100vh",
    minHeight: "100dvh",
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
    backgroundColor: "rgba(255, 255, 255, 0.92)",
  },
  logoLoaderWrap: {
    position: "relative",
    width: 112,
    height: 112,
    flex: "0 0 112px",
    margin: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  progressRing: {
    position: "absolute",
    inset: 0,
    borderRadius: "50%",
    border: "4px solid rgba(23, 34, 52, 0.12)",
    borderTopColor: "#172234",
    animation: "hosted-payment-logo-spin 1.4s linear infinite",
  },
  logoCenter: {
    width: 76,
    height: 76,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#ffffff",
    boxShadow: "0 10px 30px rgba(23, 34, 52, 0.12)",
  },
  logo: {
    width: 44,
    height: "auto",
  },
};

const AiHeaderLogo = () => (
  <img
    src="/assets/img/kc-small-logo-w.svg"
    alt="kimbocorp"
    style={paymentLoaderStyles.logo}
  />
);

const HostedPaymentLogoLoader = () => (
  <div style={paymentLoaderStyles.logoLoaderWrap}>
    <div style={paymentLoaderStyles.progressRing} />
    <div style={paymentLoaderStyles.logoCenter}>
      <AiHeaderLogo />
    </div>
  </div>
);

const HostedPaymentFullPageLoader = ({ visible }) => {
  if (!visible) return null;

  return (
    <div style={paymentLoaderStyles.overlay}>
      <style>
        {`
          @keyframes hosted-payment-logo-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
      <HostedPaymentLogoLoader />
    </div>
  );
};

export default function MyInfoCallback() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const status = queryParams.get("status");
    const result = queryParams.get("result");
    const callbackSearch = location.search || "";
    const activateBusinessReturnUrl = localStorage.getItem("activateStakeholderMyInfoReturnUrl");

    if ((status || result) && activateBusinessReturnUrl) {
      localStorage.removeItem("activateStakeholderMyInfoReturnUrl");

      const targetUrl = new URL(activateBusinessReturnUrl, window.location.origin);
      queryParams.forEach((value, key) => {
        if (key === "id" && targetUrl.searchParams.has("id")) {
          targetUrl.searchParams.set("myinfoId", value);
          return;
        }
        targetUrl.searchParams.set(key, value);
      });
      targetUrl.searchParams.set("step", "2");

      if (targetUrl.origin === window.location.origin) {
        navigate(`${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`, { replace: true });
      } else {
        window.location.href = targetUrl.toString();
      }
      return undefined;
    }

    if (status || result) {
      let appOpened = false;

      const markAppOpened = () => {
        if (document.hidden) {
          appOpened = true;
        }
      };

      document.addEventListener("visibilitychange", markAppOpened);

      window.location.href = `kimbocorp://myinfo-callback${callbackSearch}`;

      const secondAttempt = setTimeout(() => {
        if (!appOpened && !document.hidden) {
          window.location.href = `kimbocorp://kimbocorp.com/myinfo-callback${callbackSearch}`;
        }
      }, 800);

      const webFallback = setTimeout(() => {
        if (!appOpened && !document.hidden) {
          navigate(`${RoutesPaths.MYINFO_STATUS_CALLBACK}${callbackSearch}`, { replace: true });
        }
      }, 1800);

      return () => {
        document.removeEventListener("visibilitychange", markAppOpened);
        clearTimeout(secondAttempt);
        clearTimeout(webFallback);
      };
    }

    navigate(`${RoutesPaths.MYINFO_STATUS_CALLBACK}${callbackSearch}`, { replace: true });
  }, [location.search, navigate]);

  return (
    <HostedPaymentFullPageLoader visible={true} />
  );
}
